<template>
  <VanPopup
    :show="show"
    class="colorful-bg border-2 border-white w-[300px]"
    closeable
    position="center"
    round
    @update:show="emit('update:show', $event)"
    teleport="body"
  >
    <div
      class="flex flex-col justify-center items-center gap-4 py-12 px-4 text-center"
    >
      <div
        class="colorful-bg w-[200px] rounded-bl-full rounded-br-full border-2 border-white/80 overflow-hidden relative drop-shadow-2xl"
      >
        <img alt="" class="w-full" src="/img/pay/pay-banner.png" />
      </div>
      <div class="flex items-center gap-1 text-base font-bold">
        <span>{{ $t(`purchase.miss.name`) }}</span>
        <img :src="useCrystalUrl()" alt="" class="w-[16px] girl" />
        <span>{{ missAmount }}</span>
      </div>
      <div class="text-sm">
        <span> {{ $t(`purchase.miss.crystal`, { amount: price }) }}</span>
        <img
          :src="useCrystalUrl()"
          alt=""
          class="w-[16px] inline-block mt-[-2px] mx-[2px]"
        />
        <span>{{ quantity }}</span>
      </div>

      <div class="grid gap-4 grid-cols-2">
        <button class="btn glass" @click="clickBuyMore">
          {{ t(`purchase.miss.other`) }}
        </button>
        <button
          class="btn btn-warning"
          @click="userStore.clickPayItem({ id: packageId, quantity })"
        >
          <span>${{ price }}</span>
        </button>
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { ApiGetCrystalPackage } from "@/apis/crystal";
import { useGlobalUser } from "@/stores/globalUser";
import { StorageGet, StorageSet } from "@/tools/localStorage";
import { sessionStorageSet } from "@/tools/sessionStorage";
import { useCrystalUrl } from "@/use/common";
import { ref } from "vue";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const userStore = useGlobalUser();
const router = useRouter();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  reqData: {
    type: Object,
  },
  missAmount: {
    type: Number,
    default: 2,
  },
});

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
});
const { t } = useI18n();
const packageId = ref(1);
const quantity = ref(30);
const price = ref(4.99);
watch(
  () => props.show,
  async (val) => {
    if (val) {
      let purchaseList: { quantity: number; price: number; id: number }[] =
        StorageGet("purchaseList") || [];
      if (purchaseList.length === 0) {
        const { itemzz } = await ApiGetCrystalPackage();
        purchaseList = itemzz;
        StorageSet("purchaseList", purchaseList);
      }
      for (let i = 0; i < purchaseList.length; i++) {
        const { quantity: _quantity, price: _price, id } = purchaseList[i];
        if (props.missAmount <= _quantity || i === purchaseList.length - 1) {
          packageId.value = id;
          quantity.value = _quantity;
          price.value = _price;
          break;
        }
      }
    }
  }
);

const clickBuyMore = () => {
  if (props.reqData) sessionStorageSet("reqData", props.reqData);
  router.push(`/crystal#1`);
};
</script>
<style scoped>
.colorful-bg {
  background-image: var(--colorful-gradient-t);
}

:deep(.van-popup__close-icon--top-right) {
  color: white;
}
</style>
